<template>
  <div class="locations-offer-tariff">
    <vz-loader :status-loader="loading"/>
    <div class="locations-offer-tariff-title flex flex-align-items-center">
      <vz-icon
        url="/svg/doc.svg"
        size="56"
        no-masked-icon
        variant="primary"
      />
      <h2 class="vz-text-align-left ml-10">
        Получите расчет тарифов<br>
        <span class="color-primary">в формате Excel</span>
      </h2>
    </div>
    <div class="locations-offer-tariff-directions flex mt-30">
      <div v-if="isRegionPage">
        <span>{{ regionText }}</span>
      </div>
      <template v-else>
        <div>
          <span>Откуда</span> {{ from.name }}
        </div>
        <div class="ml-40">
          <span>Куда</span> {{ to.name }}
        </div>
      </template>
    </div>
    <div class="locations-offer-tariff-buttons flex flex-space-between mt-30">
      <vz-button
        large
        variant="primary"
        @click="onClick"
      >
        Сформировать
      </vz-button>
      <vz-button
        large
        outline
        icon-right
        icon-size=18
        class="ml-20"
        variant="primary"
        icon-name="arrow-right"
        :to="{ name: 'tariffs' }"
      >
        Все тарифы
      </vz-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia"
import { getTariffs } from "~/api/tariffs"
import { useCityStore } from "~/stores/city"
import { ftpServerUrl } from "~/api/constant-urls"
import {LocationRegion} from '~/types/types'

const props = defineProps({
  region: {
    type: Object as PropType<LocationRegion>,
    default: () => {}
  },
})

const { $showToast } = useNuxtApp()
const { from, to } = storeToRefs(useCityStore())

const loading = ref(false)

const isRegionPage = computed(() => {
  return !!props.region?.id
})

const regionText = computed(() => {
  return isRegionPage.value 
    ? `${props.region?.name} ${props.region?.type}` 
    : ''
})

async function onClick(): Promise<void> {
  loading.value = true
  const tariffs = await getTariffs({
    from: [from.value.guid],
    to: isRegionPage.value ? [] : [to.value.guid],
    orgId: (useRoute().query?.orgId || '').toString()
  })
  loading.value = false
  if (tariffs?.length) {
    $showToast({
      title: 'Загрузка',
      text: 'Данные сформированы, загрузка началась',
      variant: 'success',
    })
    window.open(`${ftpServerUrl}${tariffs}`, '_blank')
  }
}
</script>
 
<style lang="scss" scoped>
.locations-offer-tariff {
  position: relative;
  border-radius: 4px;
  border: 1px solid $border-gray;
  box-shadow: $pub-gray-box-shadow;
  padding: 60px 50px;
  max-width: 620px;
  width: 100%;

  @media only screen and (max-width: $pub-sm) {
    max-width: 406px;
    padding: 40px;
  }

  @media only screen and (max-width: $pub-xs) {
    max-width: none;
    padding: 40px 20px;
  }

  h2 {
    margin-bottom: 0 !important;
  }

  &-title {
    @media only screen and (max-width: $pub-sm) {
      align-items: flex-start;
    }
  }

  &-directions {
    background: $box-gray;
    border-radius: 4px;
    padding: 20px 30px;
    font-weight: 500;
    font-size: 18px;
    line-height: 26px;

    @media only screen and (max-width: $pub-sm) {
      flex-direction: column;
    }

    div {
      color: $primary;

      &:last-child {
        @media only screen and (max-width: $pub-sm) {
          margin-left: 0;
          margin-top: 10px;
        }
      }
    }

    span {
      color: $font-dark;
      position: relative;
      padding-left: 15px;

      &:before {
        content: '';
        position: absolute;
        top: calc(50% - 3px);
        left: 0px;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: $primary;
      }
    }
  }

  &-buttons {
    @media only screen and (max-width: $pub-sm) {
      flex-direction: column;
    }

    .vz-button:first-child {
      max-width: 300px;
      width: 100%;
      justify-content: center;

      @media only screen and (max-width: $pub-sm) {
        max-width: none;
      }
    }

    .vz-button:last-child {
      @media only screen and (max-width: $pub-sm) {
        width: 100%;
        justify-content: center;
        margin-top: 10px;
        margin-left: 0;
      }
    }
  }
}
</style>